import React, { useState } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab } from '@mui/material';
import { handleValidateCodevalue } from '../../Utility/constant';
import { useSelector } from 'react-redux';
import ProductPage from './index';
import VendorTab from '../Vendor/index';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { i18nRegistry } from '../../Utility/i18nRegistry';
import './product.css';

const ProductVendorTab = ({}) => {
    const location = useLocation();

    const [selectedTab, setSelectedTab] = useState(location?.state?.goToMenu ||  "PRODUCT_SIDEBAR_MENU");

    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
       
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
        i18nRegistry.clear();
    };
    

    return (

        <Box className="product-vendor-tabs">
                  
            <TabContext value={selectedTab}>
                   <Box className="product-vendor-tab-list">
                        <TabList onChange={handleChange} variant ="standard" aria-label="configuration Menu" allowScrollButtonsMobile>
                            <Tab value={"PRODUCT_SIDEBAR_MENU"} key={"PRODUCT_SIDEBAR_MENU"} label={handleValidateCodevalue(internationalise,"PRODUCT_SIDEBAR_MENU")}/>
                        {specificRolePermission?.isVendorView &&
                            <Tab value={"VENDOR_SIDEBAR_MENU"} key={"VENDOR_SIDEBAR_MENU"} label={handleValidateCodevalue(internationalise, "VENDOR_SIDEBAR_MENU")} />
                        }
                        </TabList>
                    </Box>
                    <TabPanel value={"PRODUCT_SIDEBAR_MENU"}>
                        <ProductPage 
                        
                        />
                    </TabPanel>

                    <TabPanel value={"VENDOR_SIDEBAR_MENU"}>
                        <VendorTab

                        />
                    </TabPanel>
                    
            </TabContext>
      
        </Box> 

    )

}

export default ProductVendorTab;